<template>
    <div class="aboutblue-box">
        <div class="aboutblue-center-box">
            <div class="text-box">
                <h3 class="caption">{{aboutblueData.caption}}</h3>
                <div class="center" v-html='aboutblueData.center'></div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'AboutBlue',
        data() {
            return {
                aboutblueData: {
                    caption: '关于蓝鲸 ...',
                    center: '<p>蓝鲸数字科技是一家运用数字化营销技术帮助优质的中国出口企业在海外市场树立品牌的公司。</p><p>我们认为中国制造业从来都不缺乏有匠人精神的制造商，但是缺乏建立品牌和形象的想法和方法，所以我们致力于为客户提供一整套完整的海外数字化媒体营销方案。为出口企业打造丰富多元的企业内容展现和线上营销一站式解决方案，帮助客户完成营销过程的全自动化管理。</p>'
                }
            }
        }
    }
</script>
<style scoped>
    .aboutblue-box {
        background-color: #ffffff;
        padding-top: 150px;
    }

    .aboutblue-center-box {
        height: 1012px;
        background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/about/c3859c99f959800bf25e15476e4c506.jpg') no-repeat center center;
        background-size: cover;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        background-attachment: fixed;
    }

    .text-box {
        position: relative;
        width: 920px;
        padding: 100px 176px;
        border: 1px solid #ffffff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 3;
    }

    .aboutblue-center-box::after {
        display: block;
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, .59);
    }

    .caption {
        font-size: 40px;
        font-weight: bold;
        line-height: 140%;
        max-width: 200px;
        text-align: center;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 33px;
        letter-spacing: 10px;
    }

    .center>>>p {
        font-size: 16px;
        font-weight: 400;
        line-height: 30px;
        color: rgba(255, 255, 255, 1);
        text-indent: 32px;
    }

    @media(max-width: 995px) {
        .aboutblue-center-box {
        background-attachment: initial;
    }
        .aboutblue-box {
            padding-top: 0;
        }

        .aboutblue-center-box {
            height: auto;
            padding: 5%;
        }

        .text-box {
            padding: 5%;
        }

        .caption {
            font-size: 30px;
        }
    }

    /* @media(max-width: 550px) {
        .aboutblue-box {
            padding-top: 80vh;
        }
    }

    @media(max-width: 375px) {
        .aboutblue-box {
            padding-top: 105vh;
        }
    } */

    /* @media(max-width: 1023px) {
        .aboutblue-box {
            background-color: transparent;
        }
        .aboutblue-center-box {
        height: auto;
        padding: 5% 0;
        background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/about/c3859c99f959800bf25e15476e4c506.jpg') no-repeat center center;
        background-size: cover;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        background-attachment: fixed;
    }
        .text-box {
            width: 90%;
            padding: 5%;
        }

        .caption {
            font-size: 75px;
            line-height: 140%;
            max-width: 25%;
        }

        .center>>>p {
            font-size: 50px;
            line-height: 187.5%;
            text-indent: 100px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/about/aboutblue.vue